import React, { Component } from 'react'
import {
    MDBContainer,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBIcon
  } from 'mdbreact';
  import { api } from '../../api';
  import Swal from 'sweetalert2'

export default class Modaleditstatus4 extends Component {
    constructor(props) {
        super(props);
this.state = {
    modal: false,
    id_room:'',
    numberroom:'',

}

 this.updatestatusopenroom = this.updatestatusopenroom.bind(this);
// this.handleChange2 = this.handleChange2.bind(this);
// this.handleChange3 = this.handleChange3.bind(this);
// this.handleSubmit = this.handleSubmit.bind(this);
// this.toggle = this.toggle.bind(this);
// this.handleChange4 = this.handleChange4.bind(this);
//this.getExpert = this.getExpert.bind(this);
}

toggle = () => {
    this.setState({
      modal: !this.state.modal,
      id_room: this.props.id_room ,
      numberroom: this.props.numberroom
    });
  }

  updatestatusopenroom (){
           
    setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id", this.state.id_room);
      api.post("lkupdatestatusroom4.php",datafrm,{
       headers: {
                 'content-type': 'multipart/form-data'
                }
                })
                        .then(res => {
                           // console.warn(res);
                           // console.log("response: ", res)
                            if (res.status=== 200) {

                          Swal.fire({
                            title: 'คืนมัดจำห้องสำเร็จ',
                            icon: 'success',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                            this.props.getroom();
                            this.toggle();
                           // this.getwork();
                           // window.location.href = '/'
                          })

                            }else{
                            // window.location.href = '/'
                            }

                        })

            }, 1000);

  }


  render() {
    console.log(this.state.id_room)
    return (
      <MDBContainer>
        <MDBBtn color="dark" onClick={this.toggle}><MDBIcon icon="chalkboard-teacher" /> จัดการ</MDBBtn>
        <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
          <MDBModalHeader toggle={this.toggle}>จัดการห้อง </MDBModalHeader>

          <MDBModalBody>
          <h3>ห้องที่ {this.props.numberroom}</h3> 
          <MDBBtn color="deep-purple" onClick={this.updatestatusopenroom}><MDBIcon icon="bed" /> คืนมัดจำและรอทำความสะอาด</MDBBtn>
          </MDBModalBody>

          <MDBModalFooter>
            <MDBBtn color="secondary" size="sm" onClick={this.toggle}>ปิด</MDBBtn>
            {/* <MDBBtn color="primary" size="sm">Save changes</MDBBtn> */}
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    )
  }
}
